import React from 'react';

const BetaVersion = ({ onClose }) => {
    return (
        <div className="beta-overlay">
            <style>
                {`
                .beta-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0, 0, 0, 0.4);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    z-index: 9999;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 40px 20px; /* Extra top padding for the badge space */
                }

                .glass-card {
                    position: relative;
                    background: rgba(255, 255, 255, 0.85);
                    backdrop-filter: blur(20px) saturate(180%);
                    -webkit-backdrop-filter: blur(20px) saturate(180%);
                    border: 1px solid rgba(255, 255, 255, 0.6);
                    border-radius: 24px;
                    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
                    text-align: center;
                    /* REMOVED overflow here so badge can hang outside */
                }

                .card-content-wrapper {
                    /* Moved scrolling logic here */
                    max-height: 80vh;
                    overflow-y: auto;
                    padding: 3rem;
                    box-sizing: border-box;
                    border-radius: 24px;
                }

                .beta-badge {
                    position: absolute;
                    background: #6c5b7b;
                    color: white;
                    padding: 8px 16px;
                    border-radius: 10px;
                    font-size: 12px;
                    font-weight: 800;
                    z-index: 10000;
                    box-shadow: 0 6px 15px rgba(0,0,0,0.3);
                    white-space: nowrap;
                    /* The 3D effect: tilted and hanging off */
                    top: -12px;
                    left: -20px;
                    transform: rotate(-8deg);
                }

                /* --- 1. Desktop Styles --- */
                .glass-card {
                    width: 500px;
                }
                .beta-heading {
                    font-size: 2.2rem;
                    font-weight: 800;
                    margin: 0 0 15px;
                    line-height: 1.1;
                    color: #222;
                }
                .beta-text {
                    color: #444;
                    font-size: 1.05rem;
                    line-height: 1.6;
                }

                /* --- 2. Mobile Portrait --- */
                @media (max-width: 768px) {
                    .glass-card {
                        width: 95%;
                    }
                    .card-content-wrapper {
                        padding: 2.5rem 1.5rem;
                    }
                    .beta-badge {
                        /* On mobile, we keep the tilt but nudge it in slightly */
                        left: -10px; 
                        top: -15px;
                        font-size: 11px;
                    }
                    .beta-heading {
                        font-size: 1.6rem;
                    }
                }

                /* --- 3. Mobile Landscape Fix --- */
                @media (max-height: 450px) and (orientation: landscape) {
                    .card-content-wrapper {
                        padding: 1.5rem 2rem;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }
                    .beta-heading {
                        font-size: 1.3rem;
                        margin: 0;
                    }
                    .beta-text {
                        font-size: 0.9rem;
                    }
                    .beta-badge {
                        /* Scale down instead of hiding to keep the look */
                        transform: rotate(-8deg) scale(0.8);
                        top: -10px;
                        left: -10px;
                    }
                }

                .beta-button {
                    width: 100%;
                    margin-top: 25px;
                    padding: 15px 0;
                    background: #c06c84;
                    color: white;
                    border: none;
                    border-radius: 14px;
                    font-size: 16px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.2s;
                }
                .beta-button:hover { opacity: 0.9; }
                .beta-button:active { transform: scale(0.98); }

                /* Custom Scrollbar for the inner content */
                .card-content-wrapper::-webkit-scrollbar {
                    width: 6px;
                }
                .card-content-wrapper::-webkit-scrollbar-thumb {
                    background: rgba(0,0,0,0.1);
                    border-radius: 10px;
                }
                `}
            </style>

            <div className="glass-card">
                {/* Badge is outside the content wrapper to avoid clipping */}
                <div className="beta-badge">BETA VERSION</div>

                <div className="card-content-wrapper">
                    <h2 className="beta-heading">
                        Welcome to <br /> DocG AI Beta
                    </h2>

                    <div className="beta-text">
                        <p style={{ margin: '10px 0' }}>You're accessing an early release. Features may change and data may reset.</p>
                        <p style={{ margin: '15px 0' }}>
                            <strong style={{ color: '#c06c84' }}>Bugs & Liability:</strong> This beta may contain bugs that could impact your practice operations. DocG AI is not liable for any resulting harm.
                        </p>
                        <p style={{ margin: '10px 0' }}>We appreciate your feedback!</p>
                    </div>

                    <button className="beta-button" onClick={onClose}>
                        GOT IT
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BetaVersion;